// extracted by mini-css-extract-plugin
export default {"imageContainer":"J1-z","summaryPar":"K1-z","ratingCategories":"L1-z","reviewerInfo":"M1-z","reviewTypes":"N1-z","expanded":"O1-z"};